<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.parent_id" :error="form.errors.parent_id" class="pr-6 pb-8 w-full" :label="__('Padre')">
                          <option :value="null" />
                          <option v-for="s in padres" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " :label="__('Name')" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/inertia-vue3'
import SelectInput from '@/Shared/SelectInput'
export default {
  metaInfo: { title: 'Create Category' },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
    SelectInput
  },
  layout: Layout,
  props: {
      name: String,
      padres: Object,
      parent_id : ''
      // padres : Array
  },
  remember: 'form',
  data() {
    
    return {
      form: this.$inertia.form({
        name: null,
        parent_id : (this.parent_id) ? (this.parent_id) : null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('list.store'))
    },
  },
}
</script>
